import gql from 'graphql-tag';

export const getCommercialContact = gql`
  query getCommercialContact($id: ID!, $version: Int) {
    getCommercialContact(id: $id, version: $version) {
      id
      firstName
      lastName
      companyId
      jobRoleId
      deskPhone
      mobilePhone
      emailAddress
      ice
      createdAt
      createdBy
      updatedAt
      updater
      version
      Company {
        id
        name
        abbreviation
        version
      }
      JobRole {
        id
        name
      }
    }
  }
`;
